import { render, staticRenderFns } from "./TablePerimeterSecurityAnalytics.vue?vue&type=template&id=b0271bac"
import script from "./TablePerimeterSecurityAnalytics.vue?vue&type=script&lang=js"
export * from "./TablePerimeterSecurityAnalytics.vue?vue&type=script&lang=js"
import style0 from "./TablePerimeterSecurityAnalytics.vue?vue&type=style&index=0&id=b0271bac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports